export function uuidEquals(data, nextData) {
  if (!data || !nextData) return data === nextData;
  return data.uuid === nextData.uuid;
}